import { css, keyframes } from '@emotion/core';

export const styles = ({ offset, position, fill }: { offset: number; position: string; fill: string }) => {
  let container = {};

  if (position === 'inline') {
    container = css`
      display: inline;
    `;
  }
  if (position === 'center') {
    container = css`
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
    `;
  }
  if (position === 'fullscreen') {
    container = css`
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1000;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0,0,0, 0.2);
    `;
  }

  return css`
    ${container};
  `;
};

export const svg = ({ offset, fill }: { offset: number; fill: string }) => {

  const rotate = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(270deg); }
`;

  return css`
    animation: ${rotate} 1.4s linear infinite;
  `;
};

export const circle = ({ offset, fill }: { offset: number; fill: string }) => {
  const dash = keyframes`
      0% { 
          stroke-dashoffset: ${offset};
      }
      50% {
        stroke-dashoffset: ${offset / 4};
        transform: rotate(135deg);
      }
      100% {
        stroke-dashoffset: ${offset};
        transform: rotate(450deg);
      }
  `;

  return css`
    stroke: ${fill};
    stroke-dashoffset: 0;
    stroke-dasharray: ${offset};
    transform-origin: center;
    animation: ${dash} 1.4s ease-in-out infinite;
  `;
};
